import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InfoIcon, DoneIcon, AlertIcon } from "@tino-frontend/icons";
import { AlertNegativeRoot, AlertRoot } from "./alert.styles.js";
const Alert = forwardRef(
  function Alert2(inProps, ref) {
    const {
      eventId,
      iconMapping = {
        error: /* @__PURE__ */ jsx(AlertIcon, {}),
        info: /* @__PURE__ */ jsx(InfoIcon, {}),
        warning: /* @__PURE__ */ jsx(InfoIcon, {}),
        success: /* @__PURE__ */ jsx(DoneIcon, {}),
        negative: /* @__PURE__ */ jsx(InfoIcon, {})
      },
      severity,
      ...props
    } = inProps;
    if (severity === "negative") {
      return /* @__PURE__ */ jsx(
        AlertNegativeRoot,
        {
          ...props,
          ref,
          severity: "error",
          "data-eventid": eventId
        }
      );
    }
    return /* @__PURE__ */ jsx(
      AlertRoot,
      {
        ...props,
        severity,
        ref,
        iconMapping,
        "data-eventid": eventId
      }
    );
  }
);
export {
  Alert
};
//# sourceMappingURL=alert.component.js.map
